<script setup>
import {computed} from 'vue'
import {useRouter} from 'vue-router'

import Button from "@/common/Button.vue"
import {usePageEditorStore} from '@/stores/pageEditor'

const router = useRouter()
const pageEditorStore = usePageEditorStore()

const activeContent = computed(() => pageEditorStore.contentItems?.find(o => o.pageContentId === pageEditorStore.activePageContentId))
const contentAreaName = computed(() => pageEditorStore.activeContentAreaName || activeContent.value?.contentAreaName)
const contentArea = computed(() => pageEditorStore.contentAreas?.find(o => o.name === contentAreaName.value))
const sectionId = computed(() => pageEditorStore.activeSectionId || contentArea.value?.sectionId)

const sectionNumber = computed(() => {
    const sections = pageEditorStore.pageSections || []
    return sections.map(o => o.id).indexOf(sectionId.value) + 1
})

const onMouseover = () => {
    pageEditorStore.hoverSectionId = sectionId.value
}

const onMouseout = () => {
    pageEditorStore.hoverSectionId = 0
}

const selectSection = async () => {
    await pageEditorStore.goToSection({
        router: router,
        sectionId: sectionId.value
    })

    pageEditorStore.leftSidebarActiveTab = 'Content'

    pageEditorStore.scrollToSection({
        sectionId: sectionId.value
    })
}
</script>

<template>
    <div v-if="sectionNumber" class="d-inline">
        <i class="bi-chevron-compact-right mx-1 align-middle"/>

        <Button @mouseover="onMouseover" @mouseout="onMouseout" @click="selectSection"
                class="btn-sm lh-1 p-1">
            <small>Section {{ sectionNumber }}</small>
        </Button>
    </div>
</template>